import { createContext, useContext } from 'react';

export const AggregatedBulkTargetContext = createContext('product');

export const useAggregatedBulkTarget = () => useContext(AggregatedBulkTargetContext);

export default AggregatedBulkTargetContext;
